import React from "react";
import {
  FaBullseye,
  FaEye,
  FaHandshake,
  FaStar,
  FaUsers,
  FaLeaf,
  FaBalanceScale,
  FaLightbulb,
  FaShieldAlt,
  FaSmile,
  FaChartLine,
  FaBuilding,
  FaArrowRight,
} from "react-icons/fa";
import AboutBanner from "./AboutBanner";
import SisterConcerms from "./SisterConcerms";

// ইমেজ ইম্পোর্ট (প্রজেক্ট পাথ অনুযায়ী চেঞ্জ করুন)
import missionImg from "../../assets/info-img/our-values.png";
import visionImg from "../../assets/howItWork/vision.jpg";

const MissionVision = () => {
  // ১. Core Values Data
  const coreValues = [
    {
      icon: <FaHandshake size={32} className="text-info" />,
      title: "Integrity",
      description:
        "We uphold honesty, ethics, and transparency in everything we do.",
    },
    {
      icon: <FaStar size={32} style={{ color: "#BD06D3" }} />,
      title: "Excellence",
      description: "We strive for the highest quality in every project.",
    },
    {
      icon: <FaUsers size={32} className="text-info" />,
      title: "Customer First",
      description: "Every decision begins with our customers' needs.",
    },
    {
      icon: <FaLeaf size={32} style={{ color: "#BD06D3" }} />,
      title: "Sustainability",
      description: "We develop communities that respect people and nature.",
    },
    {
      icon: <FaBalanceScale size={32} className="text-info" />,
      title: "Accountability",
      description: "We take responsibility for every commitment we make.",
    },
    {
      icon: <FaLightbulb size={32} style={{ color: "#BD06D3" }} />,
      title: "Innovation",
      description: "We embrace modern ideas and smarter development practices.",
    },
  ];

  // ২. Strategic Goals Data
  const strategicGoals = [
    {
      icon: <FaShieldAlt size={28} className="text-info mb-3" />,
      title: "Secure Land Development",
      description:
        "Develop legally verified projects with complete transparency.",
    },
    {
      icon: <FaSmile size={28} style={{ color: "#BD06D3" }} className="mb-3" />,
      title: "Customer Satisfaction",
      description:
        "Build long-lasting relationships through trust and reliable service.",
    },
    {
      icon: <FaChartLine size={28} className="text-info mb-3" />,
      title: "Sustainable Growth",
      description:
        "Expand responsibly while creating valuable investment opportunities.",
    },
    {
      icon: (
        <FaBuilding size={28} style={{ color: "#BD06D3" }} className="mb-3" />
      ),
      title: "Quality Infrastructure",
      description:
        "Deliver projects with modern planning and essential facilities.",
    },
  ];

  return (
    <div className="bg-white">
      {/* 1. Hero Banner */}
      <AboutBanner
        title="MISSION & VISION"
        description="Guided by purpose, driven by excellence, and committed to creating trusted communities for generations to come."
      />

      {/* 2. Our Mission (Text + Image) */}
      <section>
        <div className="container ">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <span className="text-info text-uppercase fw-bold tracking-wider small">
                Our Purpose
              </span>
              <h2 className="display-6 fw-bold text-dark mt-2 mb-3">
                OUR <span style={{ color: "#BD06D3" }}>MISSION</span>
              </h2>
              <h4 className="fw-semibold text-dark mb-3">
                Building Trust Through Every Development
              </h4>
              <p className="text-muted fs-5 leading-relaxed mb-0">
                At Iconic Greenland, our mission is to deliver legally verified,
                strategically located, and thoughtfully planned land
                developments that provide long-term value for our customers. We
                are committed to maintaining transparency, quality, and
                professionalism in every stage of our projects, ensuring a
                secure and rewarding investment experience.
              </p>
            </div>
            <div className="col-lg-6">
              <div className="rounded-4 overflow-hidden shadow-lg border">
                <img
                  src={missionImg}
                  alt="Our Mission"
                  className="w-100 h-100 object-fit-cover"
                  style={{ minHeight: "350px", maxHeight: "450px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Our Vision (Image + Text) */}
      <section className="py-3 bg-white">
        <div className="container pt-4">
          <div className="row g-5 align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6">
              <div className="rounded-4 overflow-hidden shadow-lg border">
                <img
                  src={visionImg}
                  alt="Our Vision"
                  className="w-100 h-100 object-fit-cover"
                  style={{ minHeight: "350px", maxHeight: "450px" }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <span className="text-info text-uppercase fw-bold tracking-wider small">
                Looking Ahead
              </span>
              <h2 className="display-6 fw-bold text-dark mt-2 mb-3">
                OUR <span style={{ color: "#BD06D3" }}>VISION</span>
              </h2>
              <h4 className="fw-semibold text-dark mb-3">
                Creating Sustainable Communities for Tomorrow
              </h4>
              <p className="text-muted fs-5 leading-relaxed mb-0">
                Our vision is to become one of Bangladesh's most trusted and
                respected land development companies by building sustainable
                communities, delivering exceptional customer experiences, and
                setting new standards of excellence in the real estate industry.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 4. Our Core Values (6 Icon Cards) */}
      <section className="">
        <div className="container ">
          <div className="text-center max-w-2xl mx-auto mb-3">
            <h2 className="display-6 fw-bold text-dark">
              OUR CORE <span style={{ color: "#BD06D3" }}>VALUES</span>
            </h2>
          </div>

          <div className="row g-4">
            {coreValues.map((val, idx) => (
              <div className="col-md-6 col-lg-4" key={idx}>
                <div className="card h-100 border-0 shadow-sm p-4 rounded-4 bg-white hover-top transition">
                  <div className="mb-3">{val.icon}</div>
                  <h4 className="fw-bold text-dark mb-2">{val.title}</h4>
                  <p className="text-muted mb-0">{val.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. Our Strategic Goals (4 Cards) */}
      <section className="py-2 bg-white">
        <div className="container ">
          <div className="text-center max-w-2xl mx-auto mb-5">
            <h2 className="display-6 fw-bold text-dark ">
              STRATEGIC <span style={{ color: "#BD06D3" }}>GOALS</span>
            </h2>
          </div>

          <div className="row g-4">
            {strategicGoals.map((goal, idx) => (
              <div className="col-md-6 col-lg-3" key={idx}>
                <div className="p-4 rounded-4 bg-light h-100 border text-center">
                  {goal.icon}
                  <h5 className="fw-bold text-dark mb-2">{goal.title}</h5>
                  <p className="text-muted small mb-0">{goal.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 6. Our Commitment (Large Highlight Card) */}
      <section className=" text-dark">
        <div className="container">
          <div
            className="p-5 rounded-4  text-white position-relative overflow-hidden"
            style={{ backgroundColor: "#00bfff80" }}
          >
            <div className="row align-items-center">
              <div className="col-lg-9">
                <span className="text-dark text-uppercase fw-bold tracking-wider small">
                  Pledge of Excellence
                </span>
                <h3 className="fw-bold display-6 mb-3 text-dark ">
                  Our Unwavering Commitment
                </h3>
                <p className="fs-5 opacity-90 leading-relaxed mb-0 text-dark">
                  We are committed to delivering every project with integrity,
                  legal assurance, and professional excellence. From land
                  acquisition to registration and customer support, every step
                  reflects our dedication to quality, transparency, and
                  long-term customer satisfaction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. Future Outlook */}
      <section className="py-2 bg-white">
        <div className="container text-center py-3">
          <div className="max-w-3xl mx-auto">
            <h3 className="fw-bold display-6 text-dark mb-3">Looking Ahead</h3>
            <p className="text-muted fs-5 leading-relaxed">
              As we continue to grow, Iconic Greenland remains focused on
              developing innovative and sustainable projects that contribute to
              stronger communities and create lasting value for future
              generations.
            </p>
          </div>
        </div>
      </section>

      {/* 8. Call To Action (CTA) */}
      {/* ===== 8. Call To Action (CTA) ===== */}
      <section
        className="py-5 text-white"
        style={{ backgroundColor: "#BD06D3" }}
      >
        <div className="container text-center py-4">
          <h2 className="display-6 fw-bold text-white mb-3">
            Ready to Invest with Confidence?
          </h2>
          <p className="fs-5 opacity-90 mb-4 max-w-2xl mx-auto">
            Explore our projects and discover secure land investment
            opportunities with Iconic Greenland.
          </p>
          {/* href কে পরিবর্তন করে #available-properties করা হয়েছে */}
          <a
            href="/#available-properties"
            className="btn btn-light btn-lg px-4 py-3 rounded-pill fw-bold text-dark shadow"
          >
            Explore Projects <FaArrowRight className="ms-2" />
          </a>
        </div>
      </section>

      {/* Sister Concerns */}
      <div className="py-4">
        <SisterConcerms />
      </div>
    </div>
  );
};

export default MissionVision;
